import type { CSSProperties } from 'react';
import { wpPages } from '../../content/wpPages.generated';
import { siteIdentity } from '../../content/siteContent';
import { BlockRenderer, mediaUrl } from '../components/BlockRenderer';
import type { PageBlock } from '../../lib/types';

function isParagraph(block: PageBlock): block is Extract<PageBlock, { type: 'paragraph' }> {
  return block.type === 'paragraph';
}

export function splitHero(blocks: PageBlock[]) {
  const lead = blocks.find(isParagraph);
  const rest = lead ? blocks.filter((block) => block.id !== lead.id) : blocks;
  return { lead, rest };
}

export function heroStyleFor(heroImageId: string | null): CSSProperties | undefined {
  return heroImageId ? { backgroundImage: `url(${mediaUrl(heroImageId)})` } : undefined;
}

export function CuratedPage({ slug }: { slug: keyof typeof wpPages }) {
  const { title, blocks, heroImageId } = wpPages[slug];
  const { lead, rest } = splitHero(blocks);

  return (
    <>
      <header className={`page-hero${heroImageId ? ' page-hero--image' : ''}`} style={heroStyleFor(heroImageId)}>
        <p className="eyebrow">{siteIdentity.name}</p>
        <h1>{title}</h1>
        {lead && <p className="page-hero__lead">{lead.text}</p>}
      </header>
      <section className="prose"><BlockRenderer blocks={rest} /></section>
    </>
  );
}
